//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ex1 from '@/views/pages/applyManage/gdApply/ex1';
import ex2 from '@/views/pages/applyManage/gdApply/ex2';
export default {
  name: 'agreementShow',
  components: {
    ex1: ex1,
    ex2: ex2
  },
  data: function data() {
    return {
      dialogVisible: false,
      title: '',
      companyData: null,
      type: 0
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(row, type) {
      this.type = type;

      if (type === 0) {
        this.title = '产品代理合同';
      } else {
        this.title = '代存储、发货合作协议书';
      }

      this.dialogVisible = true;
      this.companyData = row;
    },
    clickSubmit: function clickSubmit() {}
  }
};